var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6667 14.3895C14.0044 14.7273 14.5519 14.7273 14.8897 14.3895C15.2274 14.0518 15.2274 13.5043 14.8897 13.1665L9.2231 7.49998L14.8895 1.83353C15.2273 1.49581 15.2273 0.948256 14.8895 0.610535C14.5518 0.272814 14.0043 0.272814 13.6665 0.610535L8.0001 6.27698L2.33359 0.610468C1.99587 0.272748 1.44831 0.272747 1.11059 0.610468C0.772872 0.948189 0.772872 1.49574 1.11059 1.83346L6.77711 7.49998L1.11047 13.1666C0.772748 13.5043 0.772747 14.0519 1.11047 14.3896C1.44819 14.7273 1.99574 14.7273 2.33346 14.3896L8.0001 8.72297L13.6667 14.3895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7b594d63fd8fc1ff46ac5a966f1140a4.svg";
export { ForwardRef as ReactComponent };